import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

register('blog-template', {
  onLoad() {
    const $featuredCategoriesSlider = document.querySelector(`#featured-categories__slider--${this.id}`);

    new Flickity($featuredCategoriesSlider, {
      freeScroll: false,
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      imagesLoaded: true,
      setGallerySize: true,
      cellAlign: 'left',
      watchCSS: true,
      wrapAround: false,
      groupCells: true,
    });
  },
});
